import { Component, inject, Input } from '@angular/core';
import { PlayoutAggregationDTO } from '../../services/api/api';
import { DateTransformationService } from '../../services/transformation-helper/date-transformation.service';

@Component({
  selector: 'sb-comp-playout-aggregation',
  templateUrl: './playout-aggregation.component.html',
  styleUrls: ['./playout-aggregation.component.scss'],
  standalone: false,
})
export class PlayoutAggregationComponent {
  protected readonly dateTransformation = inject(DateTransformationService);
  @Input({ required: true }) playoutAggregation: PlayoutAggregationDTO;
}
